var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q } from "@http";
import { observable, action, runInAction, computed, toJS } from "mobx";
import { toCamelCaseData } from "@common/utils";
import QuestionUtils from "one-key-question/lib/common/utils/questionUtils";
var stepQuestionStore = /** @class */ (function () {
    function stepQuestionStore() {
        this.keyQuestionsData = [];
        this.keyQuestionAnswers = "";
        this.troubleShootingData = [];
        this.questionServiceConfig = [];
        this.troubleShootingAnswers = "";
        this.loading = false;
        this.originWOtypeAndPriority = {};
        this.residentResponsibilityVisible = false;
    }
    Object.defineProperty(stepQuestionStore.prototype, "keyQuestionsDataWithAnswers", {
        get: function () {
            if (!this.keyQuestionAnswers) {
                return [];
            }
            var result = toJS(this.keyQuestionsData);
            QuestionUtils.fromAnswer(result, JSON.parse(this.keyQuestionAnswers));
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(stepQuestionStore.prototype, "troubleShootingDataWithAnswers", {
        get: function () {
            if (!this.troubleShootingAnswers) {
                return [];
            }
            var result = toJS(this.troubleShootingData);
            QuestionUtils.fromAnswer(result, JSON.parse(this.troubleShootingAnswers));
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(stepQuestionStore.prototype, "keyQuestionsReviewData", {
        get: function () {
            var result = toJS(this.keyQuestionsData);
            var answers = this.keyQuestionAnswers && JSON.parse(this.keyQuestionAnswers) || [];
            QuestionUtils.toReview(result, answers);
            return answers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(stepQuestionStore.prototype, "troubleShootingReviewData", {
        get: function () {
            var result = toJS(this.troubleShootingData);
            var answers = this.troubleShootingAnswers && JSON.parse(this.troubleShootingAnswers) || [];
            QuestionUtils.toReview(result, answers);
            return answers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(stepQuestionStore.prototype, "keyQuestionsCommitData", {
        get: function () {
            return !!this.keyQuestionAnswers ? QuestionUtils.toCommit(JSON.parse(this.keyQuestionAnswers)) : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(stepQuestionStore.prototype, "troubleShootingCommitData", {
        get: function () {
            return !!this.troubleShootingAnswers ? QuestionUtils.toCommit(JSON.parse(this.troubleShootingAnswers)) : [];
        },
        enumerable: false,
        configurable: true
    });
    stepQuestionStore.prototype.setParam = function (key, value) {
        var _a;
        Object.assign(this, (_a = {}, _a[key] = value, _a));
    };
    stepQuestionStore.prototype.init = function (serviceParam) {
        var _this = this;
        this.loading = true;
        Promise.all([
            this.getServiceCodeQuestion(serviceParam),
            this.getCommonQuestion(serviceParam),
        ]).then(function () {
            runInAction(function () {
                _this.loading = false;
            });
        });
    };
    stepQuestionStore.prototype.setOriginWOtypeAndPriority = function (item) {
        this.originWOtypeAndPriority = {
            wotypeId: item.wotypeId,
            priority: item.priority
        };
    };
    stepQuestionStore.prototype.getCommonQuestion = function (serviceParam) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCommonQuestion(serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.keyQuestionsData = toCamelCaseData(data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    stepQuestionStore.prototype.getServiceCodeQuestion = function (serviceParam) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getServiceCodeQuestion(serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (!data || (data && data.length === 0)) {
                                _this.troubleShootingData = [];
                                _this.clearTroubleshootingAnswers();
                            }
                            else {
                                _this.troubleShootingData = toCamelCaseData(data);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    stepQuestionStore.prototype.clear = function () {
        this.keyQuestionAnswers = "";
        this.troubleShootingAnswers = "";
    };
    stepQuestionStore.prototype.clearTroubleshootingAnswers = function () {
        this.troubleShootingAnswers = "";
    };
    stepQuestionStore.prototype.setResidentResponsibilityVisible = function (visible) {
        this.residentResponsibilityVisible = visible;
    };
    stepQuestionStore.prototype.getQuestionServiceAnswerConfigs = function (serviceParam) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getQuestionAnswerTriggerConfigs(serviceParam)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (!data || (data && data.length === 0)) {
                                _this.questionServiceConfig = [];
                            }
                            else {
                                _this.questionServiceConfig = toCamelCaseData(data);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    stepQuestionStore.prototype.api = function () {
        return {
            getCommonQuestion: function (param) {
                return Q(http.post(buildURL(param) + "/commonQuestion"));
            },
            getServiceCodeQuestion: function (param) {
                return Q(http.post(buildURL(param) + "/serviceCodeQuestion"));
            },
            getQuestionAnswerTriggerConfigs: function (params) {
                return Q(http.get("RSP/NewRequest/QuestionAnswerTriggerConfigs", { params: params }));
            },
        };
    };
    __decorate([
        observable
    ], stepQuestionStore.prototype, "keyQuestionsData", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "keyQuestionAnswers", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "troubleShootingData", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "questionServiceConfig", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "troubleShootingAnswers", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "originWOtypeAndPriority", void 0);
    __decorate([
        observable
    ], stepQuestionStore.prototype, "residentResponsibilityVisible", void 0);
    __decorate([
        computed
    ], stepQuestionStore.prototype, "keyQuestionsDataWithAnswers", null);
    __decorate([
        computed
    ], stepQuestionStore.prototype, "troubleShootingDataWithAnswers", null);
    __decorate([
        computed
    ], stepQuestionStore.prototype, "keyQuestionsReviewData", null);
    __decorate([
        computed
    ], stepQuestionStore.prototype, "troubleShootingReviewData", null);
    __decorate([
        computed
    ], stepQuestionStore.prototype, "keyQuestionsCommitData", null);
    __decorate([
        computed
    ], stepQuestionStore.prototype, "troubleShootingCommitData", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "setParam", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "init", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "setOriginWOtypeAndPriority", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "getCommonQuestion", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "getServiceCodeQuestion", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "clear", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "clearTroubleshootingAnswers", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "setResidentResponsibilityVisible", null);
    __decorate([
        action.bound
    ], stepQuestionStore.prototype, "getQuestionServiceAnswerConfigs", null);
    return stepQuestionStore;
}());
export default stepQuestionStore;
export var buildURL = function (serviceParam) {
    return "RSP/NewRequest/" + serviceParam.serviceCategoryId + "/" + serviceParam.serviceTypeId + "/" + serviceParam.serviceCodeId;
};
